export const SET_GLOBALLOADING = 'SET_GLOBALLOADING'
export const SET_EQUIPMENT_CRAFT = 'SET_EQUIPMENT_CRAFT'
export const SET_EQUIPMENT_DATA = 'SET_EQUIPMENT_DATA'
export const SET_EQUIPMENT_ENHANCE_RATE_DATA = 'SET_EQUIPMENT_ENHANCE_RATE_DATA'
export const SET_QUEST_DATA = 'SET_QUEST_DATA'
export const SET_QUEST_REWARD_DATA = 'SET_QUEST_REWARD_DATA'
export const SET_QUEST_AREA_DATA = 'SET_QUEST_AREA_DATA'
export const SET_WAVE_GROUP_DATA = 'SET_WAVE_GROUP_DATA'
export const SET_ENEMY_REWARD_DATA = 'SET_ENEMY_REWARD_DATA'
export const SET_UNIT_DATA = 'SET_UNIT_DATA'
export const SET_ACTUAL_UNIT_BACKGROUND = 'SET_ACTUAL_UNIT_BACKGROUND'
export const SET_UNIT_PROFILE = 'SET_UNIT_PROFILE'
export const SET_UNIT_PROMOTION = 'SET_UNIT_PROMOTION'
export const SET_UNIT_SKILL_DATA = 'SET_UNIT_SKILL_DATA'
export const SET_UNIT_ATTACK_PATTERN = 'SET_UNIT_ATTACK_PATTERN'
export const SET_SKILL_DATA = 'SET_SKILL_DATA'
export const SET_EXPERIENCE_UNIT = 'SET_EXPERIENCE_UNIT'
export const SET_EXPERIENCE_TEAM = 'SET_EXPERIENCE_TEAM'
export const SET_GRAND_ARENA_DAILY_RANK_REWARD = 'SET_GRAND_ARENA_DAILY_RANK_REWARD'
export const SET_GRAND_ARENA_DEFENCE_REWARD = 'SET_GRAND_ARENA_DEFENCE_REWARD'
export const SET_GRAND_ARENA_MAX_RANK_REWARD = 'SET_GRAND_ARENA_MAX_RANK_REWARD'
export const SET_GRAND_ARENA_TIME_RANK_REWARD = 'SET_GRAND_ARENA_TIME_RANK_REWARD'
export const SET_ARENA_DAILY_RANK_REWARD = 'SET_ARENA_DAILY_RANK_REWARD'
export const SET_ARENA_DEFENCE_REWARD = 'SET_ARENA_DEFENCE_REWARD'
export const SET_ARENA_MAX_RANK_REWARD = 'SET_ARENA_MAX_RANK_REWARD'
export const SET_ARENA_TIME_RANK_REWARD = 'SET_ARENA_TIME_RANK_REWARD'
export const SET_CHARA_IDENTITY = 'SET_CHARA_IDENTITY'
export const SET_SKILL_COST = 'SET_SKILL_COST'
export const SET_ENEMY_PARAMETER = 'SET_ENEMY_PARAMETER'
export const SET_SKILL_ACTION = 'SET_SKILL_ACTION'
export const SET_UNIT_UNIQUE_EQUIP = 'SET_UNIT_UNIQUE_EQUIP'
export const SET_UNIQUE_EQUIPMENT_DATA = 'SET_UNIQUE_EQUIPMENT_DATA'
export const SET_UNIQUE_EQUIPMENT_ENHANCE_DATA = 'SET_UNIQUE_EQUIPMENT_ENHANCE_DATA'
export const SET_UNIQUE_EQUIPMENT_ENHANCE_RATE = 'SET_UNIQUE_EQUIPMENT_ENHANCE_RATE'
export const SET_UNIT_PROMOTION_STATUS = 'SET_UNIT_PROMOTION_STATUS'
export const SET_UNIT_RARITY = 'SET_UNIT_RARITY'
export const SET_CHARA_STORY_STATUS = 'SET_CHARA_STORY_STATUS'
export const SET_USER_STATUS = 'SET_USER_STATUS'
export const SET_EX_EQUIPMENT_CATEGORY = 'SET_EX_EQUIPMENT_CATEGORY'
export const SET_EX_EQUIPMENT_DATA = 'SET_EX_EQUIPMENT_DATA'
export const SET_EX_EQUIPMENTENHANCE_DATA = 'SET_EX_EQUIPMENTENHANCE_DATA'
export const SET_TALENT_QUEST_DATA = 'SET_TALENT_QUEST_DATA'
export const SET_TALENT_QUEST_AREA_DATA = 'SET_TALENT_QUEST_AREA_DATA'
export const SET_UNIT_TALENT = 'SET_UNIT_TALENT'